module.exports = __webpack_public_path__ + "img/1-3.3f13120c.svg";